import { AutoComplete } from "antd";
import { useIntl } from "react-intl";

import { useEventSelect } from "./hooks";
import { EventSelectProps } from "./types";

const EventSelect: React.FC<EventSelectProps> = ({
  value,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const eventSelect = useEventSelect({ value, onChange });

  return (
    <AutoComplete
      {...eventSelect}
      placeholder={intl.formatMessage({ defaultMessage: "Choose Event" })}
      {...props}
    />
  );
};

export default EventSelect;
